import { JourneyService } from 'src/app/angularJS/services/journey/journey.service';

import { UsageEventService } from 'src/app/angularJS/services/usage-event/usage-event.service';

import { PaymentService } from 'src/app/angularJS/services/payments/payments.service';

import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';

import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';

import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

import { ChargeAccountService } from 'src/app/angularJS/services/charge-account/charge-account.service';

export class UnratedJourneysController {
  public static $inject = [
    '$rootScope',
    'journeyService',
    'usageEventService',
    'paymentService',
    'LinkBuilder',
    'QueryBuilder',
    'ACTToolbarService',
    'chargeAccountService'
  ];
  public unratedJourneys: Array<InterACT.Interfaces.Journeys.Journey> = [];
  public journeyToMediaIdDictionary: InterACT.Interfaces.IDictionary<string> = {};
  public journeyFilters = {
    fromDate: undefined,
    toDate: undefined
  };
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };

  constructor(
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    private journeyService: JourneyService,
    private usageEventService: UsageEventService,
    private paymentService: PaymentService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder,
    private toolbarService: ACTToolbarService,
    private chargeAccountService: ChargeAccountService) {
    this.activate();
  }

  /**
   * A method is called whenever any of the filters on this controller have changed
   */
  public onFilterChanged = () => {
    return this.getUnratedJourneys(this.paginatorData.currentPage, this.paginatorData.perPageCount);
  };

  /**
 * A method that gets the mode of a given journey
 * @param journey the journey to get the mode for
 */
  public getJourneyMode(journey: InterACT.Interfaces.Journeys.Journey) {
    if (!journey.journeyLegs || journey.journeyLegs.length === 0) {
      return 'NA';
    }

    const firstJourneyLegMode = journey.journeyLegs[0].mode;
    const otherModes = journey.journeyLegs.filter((journeyLeg) => {
      return journeyLeg.mode !== firstJourneyLegMode;
    });

    return otherModes.length > 0 ? 'MULTIPLE' : firstJourneyLegMode;
  }

  /**
   * A method that adds an entry into the journey to media id dictionary for the supplied journey
   * @param unratedJourney the journey to use to populate the dictionary
   */
  private populateMediaIdDictionaryForJourney = (unratedJourney: InterACT.Interfaces.Journeys.Journey) => {
    let usageEventIds = this.unratedJourneys.map((unratedJourney) => {
      return unratedJourney.usageEvents.length > 0 ? unratedJourney.usageEvents[0].link.split('/').pop() : undefined;
    });

    usageEventIds = usageEventIds.filter((usageEventId) => {
      return usageEventId !== undefined;
    });

    if (usageEventIds.length === 0) {
      return;
    }

    const query = this.queryBuilder.newParam().fieldIn('id', usageEventIds).getParam();

    this.usageEventService.getList(1, 1000, query).then((response) => {
      if (response.usageEvents.length === 0) {
        return;
      }

      const usageTokenLink = response.usageEvents[0].usageEvent.token.link;
      const query = this.queryBuilder.newParam().fieldIs('usageTokens.link', usageTokenLink).getParam();

      this.chargeAccountService.getChargeAccounts(1, 1, query).then((response: Array<InterACT.Interfaces.ChargeAccounts.ChargeAccount>) => {
        if (response.length === 0) {
          return;
        }

        if (response[0].paymentToken.length === 0) {
          return;
        }

        const paymentTokenId = response[0].paymentToken[0].link.split('/').pop();
        this.paymentService.getPaymentToken(paymentTokenId).then((response) => {
          if (!response.paymentToken) {
            return;
          }

          this.journeyToMediaIdDictionary[unratedJourney.id] = response.paymentToken.token;
        });
      });
    });
  };

  /**
   * A method that gets a page worth or unrateable journeys
   * @param page the page number to retrieve
   * @param perPage the number of unrateable journeys to retrieve per page
   */
  private getUnratedJourneys = (page: number, perPage: number) => {
    this.$rootScope.showSpinner = true;

    if (!page) {
      page = this.paginatorData.currentPage;
    }

    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    const query = this.constructQueryString();

    this.journeyService.getList(page, perPage, query).then((response: InterACT.Interfaces.Journeys.JourneysResponse) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.$rootScope.showSpinner = false;
      this.unratedJourneys = response.journeys;
      this.journeyToMediaIdDictionary = {};

      this.unratedJourneys.forEach((unratedJourney) => {
        this.populateMediaIdDictionaryForJourney(unratedJourney);
      });
    });
  };

  /**
   * A method that constructs a qParam query string based on the selected filters held on this controller
   */
  private constructQueryString() {
    let query = this.queryBuilder.newParam()
      //.fieldIs('status', 'COMPLETE').getParam();
      .fieldIs('status', 'UNRATEABLE').getParam();

    if (this.journeyFilters.fromDate) {
      query += ' and startDateTime >= \'' + new Date(this.journeyFilters.fromDate).toISOString() + '\'';
    }

    if (this.journeyFilters.toDate) {
      query += ' and endDateTime <= \'' + new Date(this.journeyFilters.toDate).toISOString() + '\'';
    }

    query += ' sortBy created desc';

    return query;
  }

  /**
   * A method that is called during controller instantiation
   */
  private activate() {
    this.toolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('UNRATED_JOURNEYS');
    });
  }
}